import { render, staticRenderFns } from "./Decimal.vue?vue&type=template&id=365fa62e"
import script from "./Decimal.vue?vue&type=script&lang=js"
export * from "./Decimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports